module.exports = __webpack_public_path__ + "static/knittedblueteddymain-157fac0cdbcae7f1a4deb1ce73ceb55b.jpeg";